<template>
  <v-layout style="padding-bottom: 5px;">
    <v-flex style="vertical-align: middle" class="text-truncate">{{ stock[1] }}</v-flex>

    <v-flex shrink class="text-xs-right" style="white-space: nowrap;">
      <div style="display: inline-block;">
        <template v-if="isNotOtherShipping">
          <v-btn
            small
            fab
            color="primary"
            outline
            class="extra-small ma-0"
            v-if="
              (!(
                selectedBot.useketshop == true &&
                selectedBot.ketshop_api_key &&
                selectedBot.ketshop_api_secret
              ) &&
                !(selectedBot.packhai_status == true && selectedBot.packhai_token)) ||
                productBy === 'lineMyShop'
            "
            @click="removeCount()"
            :disabled="
              stock[2] == this.min ||
                addloading ||
                ($store.getters.getPackage != 'premium' && indexProduct >= getPackageConfig().products)
            "
          >
            <span class="fa fa-minus"></span>
          </v-btn>
        </template>

        <span
          style="width: 30px;display:inline-block;margin-left:5px;margin-right:5px;text-align:center"
          >{{ stock[2] }}</span
        >
        <template v-if="isNotOtherShipping">
          <v-btn
            small
            fab
            color="primary"
            outline
            class="extra-small ma-0"
            v-if="
              (!(
                selectedBot.useketshop == true &&
                selectedBot.ketshop_api_key &&
                selectedBot.ketshop_api_secret
              ) &&
                !(selectedBot.packhai_status == true && selectedBot.packhai_token)) ||
                productBy === 'lineMyShop'
            "
            @click="addCount()"
            :disabled="
              stock[2] == this.max - 1 ||
                deleteloading ||
                ($store.getters.getPackage != 'premium' && indexProduct >= getPackageConfig().products)
            "
          >
            <span class="fa fa-plus"></span>
          </v-btn>
        </template>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: ['value', 'productId', 'refCode', 'productBy', 'indexProduct'],
  data: function() {
    return {
      stock: this.value,
      max: 10000,
      min: 0,
      addloading: false,
      deleteloading: false
    }
  },
  watch: {
    value: function() {
      this.stock = this.value
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isNotOtherShipping() {
      const vm = this
      return !vm.refCode || (vm.refCode && !vm.refCode.includes('ZORTOUT'))
    }
  },
  methods: {
    async removeCount() {
      const vm = this
      if (vm.stock[2] > vm.min) {
        vm.stock[2] = parseInt(vm.stock[2]) - 1
        let stock = [
          vm.stock[0],
          vm.stock[1],
          vm.stock[2],
          vm.stock[3],
          vm.stock[4],
          vm.stock[5],
          vm.stock[6]
        ]
        const data = {
          pageid: vm.selectedBot.pageid,
          inventory_id: vm.stock[0],
          body: { amount: 1 }
        }
        if (vm.productBy === 'lineMyShop') {
          vm.$emit('input', stock)
          await api.decreaseProductLineMyShop(data)
        } else {
          vm.updateStock('productstockdelete')
          vm.$emit('input', stock)
        }
      }
    },
    async addCount() {
      const vm = this
      if (vm.stock[2] < vm.max) {
        vm.stock[2] = parseInt(vm.stock[2]) + 1
        let stock = [
          vm.stock[0],
          vm.stock[1],
          vm.stock[2],
          vm.stock[3],
          vm.stock[4],
          vm.stock[5],
          vm.stock[6]
        ]
        const data = {
          pageid: vm.selectedBot.pageid,
          inventory_id: vm.stock[0],
          body: { amount: 1 }
        }
        if (vm.productBy === 'lineMyShop') {
          vm.$emit('input', stock)
          await api.increaseProductLineMyShop(data)
        } else {
          vm.updateStock('productstockadd')
          vm.$emit('input', stock)
        }
      }
    },
    updateStock: function(operation) {
      let vm = this
      // let productstock = {
      //   id: vm.stock[0],
      //   option: vm.stock[1],
      //   productid: this.productId,
      //   quantity: vm.stock[2],
      //   price: vm.stock[3],
      //   discountprice: vm.stock[4]
      // }
      // api.editProductStock(productstock, function(error, response) {
      //   if (error) {
      //     console.error(error)
      //   }
      // })

      var data = { productstockid: this.stock[0], quantity: 1 }
      if (operation == 'productstockadd') {
        // vm.addloading = true
        api.productstockadd(data, (error, response) => {
          // vm.addloading = false
        })
      } else {
        // vm.deleteloading = true
        api.productstockdelete(data, (error, response) => {
          // vm.deleteloading = false
        })
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/StockItem.vue